import { DEFAULT_OG_IMAGE_URL } from "@/app/_utils/constants";

/** Normalize GCS / legacy URLs to the public storage.googleapis.com form. */
export function toPublicAssetUrl(raw: string | null | undefined): string {
  const value = typeof raw === "string" ? raw.trim() : "";
  if (!value) return "";
  if (value.startsWith("gs://")) {
    return `https://storage.googleapis.com/${value.slice("gs://".length)}`;
  }
  return value.replace(
    /^https:\/\/storage\.cloud\.google\.com\//i,
    "https://storage.googleapis.com/"
  );
}

/**
 * OG image URL for a ticket/product page.
 * Prefer the live show creative (GCS). Only fall back to the Katz default when
 * the show has no image — never invent a missing /og-shows/ path (that 404s and
 * made share cards look like the homepage).
 */
export function showOgImageUrl(
  _slugOrId: string | null | undefined,
  imgUrl: string | null | undefined
): string {
  const source = toPublicAssetUrl(imgUrl);
  if (source) return source;
  return DEFAULT_OG_IMAGE_URL;
}
